import gql from 'graphql-tag';

import dokkioTagFacetValueFragment from './dokkioTagFacetValueFragment';

export const dokkioTagFacetFragment = gql`
  fragment dokkioTagFacetFragment on DokkioTagFacet {
    dokkioClass
    dokkioLabelID
    count
    valueMin
    valueMax
    values {
      ...dokkioTagFacetValueFragment
    }
  }
  ${dokkioTagFacetValueFragment}
`;
export default dokkioTagFacetFragment;
